import { io } from 'socket.io-client';
import eventBus from './utils/eventBus';
import { message } from 'opentok-accelerator-core/dist/logging';

let socket;

export const initializeSocket = (userId, showAlert,location, callbacks={}) => {

  const { onDisconnect, onConnect } = callbacks;

  if (!socket) {
    socket = io('https://uatsocket.assistlink.io', {
      transports: ['websocket'],
      query: { userId },
      reconnection: true,
      reconnectionAttempts: Infinity,    // keep retrying forever
      reconnectionDelay: 1000,           // start with 1s
      reconnectionDelayMax: 10000,       // cap retries at 10s
      randomizationFactor: 0.5,          // jitter to avoid server overload
      timeout: 20000,                    // wait up to 20s for server response
      autoConnect: true,                 // connect immediately
    });

    socket.on('connect', () => {
      console.log('Connected via WebSocket:', socket.id);
      if (onConnect) onConnect();
    });

    socket.on('disconnect', (reason) => {
      console.warn('Disconnected:', reason);
      if (onDisconnect) onDisconnect();

      // Keep your existing reconnect logic
      if (reason === 'io server disconnect') {
        socket.connect();
      } else if (reason === 'transport close' || reason === 'ping timeout') {
        if (!socket.connected) socket.connect();
      }
    });

    socket.on("connect_error", (err) => {
      // the reason of the error, for example "xhr poll error"
      console.log(err.message);

      // some additional description, for example the status code of the initial HTTP response
      console.log(err.description);
      if (onDisconnect) onDisconnect();
      // some additional context, for example the XMLHttpRequest object
      console.log(err.context);
      console.log('Disconnected: message ' + err.message);
      console.log('Disconnected: description ' + err.description);
      console.log('Disconnected: context ' + err.context);
      console.log('Clock Ok trying to reconnect automatically now');
      socket.connect();

    });

    socket.onAny((eventName, ...args) => {
      console.log(`Received1 socket event: ${eventName} with data:`, ...args);
    });

    socket.on('NEW_MESSAGE', (data) => {

      console.log("locationSocket", location)
      eventBus.emit('NEW_MESSAGE', data);
      if (location.current != "/chat") {
        showAlert({
          title: "Incoming Chat Notification",
          message: data?.message ?? "something went wrong",
          variant: "success",
        });
      }
    });

    socket.on('NEW_SUPPORT_REQUEST', (data) => {
      console.log("NEW_SUPPORT_REQUEST", data.data)
      showAlert({
        title: "New Support Request",
        message: "Incoming " + data.data.conversationType + " request from " + data.data.createdBy.firstName + " " + data.data.createdBy.lastName + " kindly check your inbox and take action.",
        variant: "success",
      });

      eventBus.emit('NEW_SUPPORT_REQUEST', data?.data);

    });

    socket.on('NEW_INTERNAL_REQUEST', (data) => {
      console.log("NEW_INTERNAL_REQUEST", data.data)
      showAlert({
        title: "New Internal Request",
        message: "Incoming internal " + data.data.conversationType + " request from " + data.data.createdBy.firstName + " " + data.data.createdBy.lastName + " kindly check your inbox and take action.",
        variant: "success",
      });

      eventBus.emit('NEW_INTERNAL_REQUEST', data?.data);

    });

    socket.on('END_SUPPORT_REQUEST', (data) => {
      console.log("END_SUPPORT_REQUEST", data?.data)
      eventBus.emit('END_SUPPORT_REQUEST', data?.data);
      if (data.data.conversationStatus == "Cancelled") {
        showAlert({
          title: "Cancelled Support Request",
          message: "Your " + data.data.conversationType + " request from " + data.data.createdBy.firstName + " " + data.data.createdBy.lastName + " has been " + data.data.conversationStatus.toLowerCase() + " by another user.",
          variant: "warning",
        });
      } else if (data.data.conversationStatus == "Assigned") {
        const anotherMember = data?.data?.conversationMembers?.find((e) => e.user_id != data?.data?.createdBy.id);
        showAlert({
          title: "Support Request Assigned",
          message: "Your " + data.data.conversationType + " request has be accepted by  " + anotherMember?.user?.firstName + " " + anotherMember?.user?.lastName + " .",
          variant: "success",
        });
      } else {
        showAlert({
          title: "Support Request Completed",
          message: "Your " + data.data.conversationType + " request from " + data.data.createdBy.firstName + " " + data.data.createdBy.lastName + " has been " + data.data.conversationStatus.toLowerCase() + " by another user.",
          variant: "success",
        });
      }

    });

    socket.on('ACCEPT_REQUEST', (data) => {
      console.log("ACCEPT_REQUEST", data?.data)
      // alert("ACCEPT_REQUEST")
      const anotherMember = data?.data?.conversationMembers?.find((e) => e.user_id != data?.data?.createdBy.id);
      eventBus.emit('ACCEPT_REQUEST', data?.data);
      showAlert({
        title: "Support Request Accepted",
        message: "Your support request with " + anotherMember?.user?.firstName + " " + anotherMember?.user?.lastName + " on " + data?.data?.startTime + " is confirmed.",
        variant: "success",
      });
    });



    socket.on('CALL_RESCHEDULED', (data) => {
      console.log("CALL_RESCHEDULED11", data?.data?.conversationStatus)

      if (location.current == "/calendar") {
        if (data?.data?.conversationStatus == "Pending") {
          eventBus.emit('RESCHEDULED_REMOVE_EVENT', data?.data);
        } else {
          eventBus.emit('RESCHEDULED_UPDATE_EVENT', data?.data);
        }

      } else if (location.current != "/inbox") {
        eventBus.emit('RESCHEDULED_UPDATE_EVENT', data?.data);
      } else {
        eventBus.emit('RESCHEDULED_UPDATE_EVENT', data?.data);
      }
      showAlert({
        title: "Call Reschedule Notification",
        message: "Your support request with " + data.data.createdBy.firstName + " " + data.data.createdBy.lastName + " is rescheduled on " + data?.data?.startTime + ".",
        variant: "success",
      });
    });

    socket.on('UPDATE_USER_STATUS', (data) => {
      console.log("UPDATE_USER_STATUS", data);
      eventBus.emit('UPDATE_USER_STATUS', data);
    });



  }
  return socket;
};

export const getSocket = () => {
  return socket;
};

export const disconnectSocket = () => {
  if (socket) {
    socket.disconnect(); // fully close the connection
    socket = null; // clear the singleton
    console.log('Socket disconnected on logout');
  }
};
